var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-booking bg-closed-inversed",style:(_vm.setStyleSlot(_vm.slotObject.step, _vm.slotObject.date))})}
var staticRenderFns = []

export { render, staticRenderFns }